"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUserData = exports.requireUserSession = exports.addUserGroupKey = exports.addPersonalSigningKey = exports.userGroupKeys = exports.clearStorage = exports.encryptObject = exports.decryptObject = exports.GROUP_MEMBERSHIPS_STORAGE_KEY = void 0;

var _encryption = require("blockstack/lib/encryption");

var _config = require("./config");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var GROUP_MEMBERSHIPS_STORAGE_KEY = 'GROUP_MEMBERSHIPS_STORAGE_KEY';
exports.GROUP_MEMBERSHIPS_STORAGE_KEY = GROUP_MEMBERSHIPS_STORAGE_KEY;

var valueToString = function valueToString(value, clazz) {
  if (clazz === Boolean) {
    return value ? 'true' : 'false';
  }

  if (clazz === Number) {
    return String(value);
  }

  if (clazz === Array || clazz === Object) {
    return JSON.stringify(value);
  }

  return value;
};

var stringToValue = function stringToValue(value, clazz) {
  if (clazz === Boolean) {
    return value === 'true';
  }

  if (clazz === Number) {
    return parseFloat(value);
  }

  if (clazz === Array || clazz === Object) {
    return JSON.parse(value);
  }

  return value;
};

var decryptObject =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(encrypted, model) {
    var privateKey, decrypted, schema;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return model.encryptionPrivateKey();

          case 2:
            privateKey = _context.sent;
            decrypted = _objectSpread({}, encrypted);
            schema = model.schema;
            Object.keys(encrypted).forEach(function (key) {
              var value = encrypted[key];
              var schemaValue = schema[key];
              var clazz = schemaValue;
              var schemaAttribute = schema[key];

              if (schemaAttribute && schemaAttribute.type) {
                clazz = schemaAttribute.type;
              }

              if (clazz && schemaAttribute && !schemaAttribute.decrypted) {
                try {
                  var decryptedValue = (0, _encryption.decryptECIES)(privateKey, value);
                  decrypted[key] = stringToValue(decryptedValue, clazz);
                } catch (error) {
                  console.debug("Decryption error for key: '".concat(key, "': ").concat(error.message)); // eslint-disable-line

                  decrypted[key] = value;
                }
              }
            });
            return _context.abrupt("return", decrypted);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function decryptObject(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.decryptObject = decryptObject;

var encryptObject =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(model) {
    var publicKey, object, encrypted;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return model.encryptionPublicKey();

          case 2:
            publicKey = _context2.sent;
            object = model.attrs;
            encrypted = _objectSpread({}, object, {
              _id: model._id
            });
            Object.keys(model.schema).forEach(function (key) {
              var schemaValue = model.schema[key];
              var schemaAttribute = model.schema[key];
              var value = object[key];
              var clazz = schemaValue;
              if (typeof value === 'undefined') return;

              if (schemaAttribute.type) {
                clazz = schemaAttribute.type;
              }

              if (schemaAttribute.decrypted) {
                encrypted[key] = value;
                return;
              }

              var stringValue = valueToString(value, clazz);
              encrypted[key] = (0, _encryption.encryptECIES)(publicKey, stringValue);
            });
            return _context2.abrupt("return", encrypted);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function encryptObject(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.encryptObject = encryptObject;

var clearStorage = function clearStorage() {
  localStorage.removeItem(GROUP_MEMBERSHIPS_STORAGE_KEY);
};

exports.clearStorage = clearStorage;

var userGroupKeys = function userGroupKeys() {
  var keysString = localStorage.getItem(GROUP_MEMBERSHIPS_STORAGE_KEY);
  var keys = keysString ? JSON.parse(keysString) : {};
  keys = _objectSpread({
    userGroups: {},
    signingKeys: {},
    personal: {}
  }, keys);
  return keys;
};

exports.userGroupKeys = userGroupKeys;

var addPersonalSigningKey = function addPersonalSigningKey(signingKey) {
  var keys = userGroupKeys();
  keys.personal = _objectSpread({
    _id: signingKey._id
  }, signingKey.attrs);
  localStorage.setItem(GROUP_MEMBERSHIPS_STORAGE_KEY, JSON.stringify(keys));
};

exports.addPersonalSigningKey = addPersonalSigningKey;

var addUserGroupKey = function addUserGroupKey(userGroup) {
  var keys = userGroupKeys();
  keys.userGroups[userGroup._id] = userGroup.attrs.signingKeyId;
  keys.signingKeys[userGroup.attrs.signingKeyId] = userGroup.privateKey;
  localStorage.setItem(GROUP_MEMBERSHIPS_STORAGE_KEY, JSON.stringify(keys));
};

exports.addUserGroupKey = addUserGroupKey;

var requireUserSession = function requireUserSession() {
  var _ref3 = (0, _config.getConfig)(),
      userSession = _ref3.userSession;

  if (!userSession) {
    // TODO: link to docs
    throw new Error('You have not properly configured your UserSession.');
  }

  return userSession;
};

exports.requireUserSession = requireUserSession;

var loadUserData = function loadUserData() {
  var _ref4 = (0, _config.getConfig)(),
      userSession = _ref4.userSession;

  if (userSession) {
    return userSession.loadUserData();
  }

  return null;
};

exports.loadUserData = loadUserData;